// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-responsive-carousel/lib/styles/carousel.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 1500px;
  position: relative;
  gap: 75px;
}

.three-tiles {
  display: flex;
  gap: 50px;
}

.work-with-us-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px 0 50px;
  max-height: 600px;
  /* object-fit:cover; */
  overflow: clip;

  background-color: #d9d9d9;
}

.work-with-us-image img {
  height: 100%;
  max-width: 35vw;
}

.work-with-us {
  /* background-color: #dddddd; */
  max-width: 100%;
  min-width: 100px;

  flex-grow: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 50px;
  gap: 2rem;
}

.work-with-us-title {
  font-family: 'Lemon/Milk';
  font-style: normal;
  font-weight: 400;
  font-size: 30px;

  color: #000000;
}

.gallery {
  position: absolute;
  top: 105px;
  height: calc(100vh - 105px);
  width: auto;
  align-content: baseline;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.9);
}

.thumbs {
  display: none;
}

u {
  text-decoration: underline;
  text-decoration-color: #6b3cb9;
}



@media (max-width: 415px) {
  .work-with-us-container {
    padding: 20px;
    width: 100%;
  }

  .work-with-us {
    padding: 5px;
  }

  .three-tiles {
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
    gap: 2rem;
  }

  .work-with-us-image {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;;EAEd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;;EAEhB,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;;;AAIA;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@import '~react-responsive-carousel/lib/styles/carousel.min.css';\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  max-width: 1500px;\n  position: relative;\n  gap: 75px;\n}\n\n.three-tiles {\n  display: flex;\n  gap: 50px;\n}\n\n.work-with-us-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 50px 0 50px;\n  max-height: 600px;\n  /* object-fit:cover; */\n  overflow: clip;\n\n  background-color: #d9d9d9;\n}\n\n.work-with-us-image img {\n  height: 100%;\n  max-width: 35vw;\n}\n\n.work-with-us {\n  /* background-color: #dddddd; */\n  max-width: 100%;\n  min-width: 100px;\n\n  flex-grow: 1;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  padding: 50px;\n  gap: 2rem;\n}\n\n.work-with-us-title {\n  font-family: 'Lemon/Milk';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 30px;\n\n  color: #000000;\n}\n\n.gallery {\n  position: absolute;\n  top: 105px;\n  height: calc(100vh - 105px);\n  width: auto;\n  align-content: baseline;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.thumbs {\n  display: none;\n}\n\nu {\n  text-decoration: underline;\n  text-decoration-color: #6b3cb9;\n}\n\n\n\n@media (max-width: 415px) {\n  .work-with-us-container {\n    padding: 20px;\n    width: 100%;\n  }\n\n  .work-with-us {\n    padding: 5px;\n  }\n\n  .three-tiles {\n    flex-direction: column;\n    align-items: center;\n    margin-top: 2rem;\n    gap: 2rem;\n  }\n\n  .work-with-us-image {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
